import React from 'react';
import { Link } from 'react-router-dom';
import './SButton.scss';

interface SButtonProps {
  to?: string;
  variant?: 'default' | 'lvl' | 'blnc';
  className?: string;
  icon?: React.ReactNode;
  label: React.ReactNode;
  sublabel: React.ReactNode;
  onClick?: () => void;
}

const SButton: React.FC<SButtonProps> = ({
  to,
  variant = 'default',
  className = '',
  icon,
  label,
  sublabel,
  onClick
}) => {
  const buttonClasses = `c-s-button ${variant !== 'default' ? `c-s-button--${variant}` : ''} ${className}`.trim();
  
  const content = (
    <>
      <div className="c-s-button__icon">{icon}</div>
      <div className="c-s-button__t">
        <span>{label}</span>
        <small>{sublabel}</small>
      </div>
    </>
  );
  
  if (to) {
    return (
      <Link to={to} className={buttonClasses} onClick={onClick}>
        {content}
      </Link>
    );
  }
  
  return (
    <button className={buttonClasses} onClick={onClick}>
      {content}
    </button>
  );
};

export default SButton; 